import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './Complaints.module.css';

export default function ComplaintsSkeleton() {
  return (
    <div className={styles.page}>
      {/* Page Header Skeleton */}
      <div className={styles.pageHeader}>
        <Skeleton width={150} height={28} />
        <Skeleton width={150} height={38} borderRadius={8} />
      </div>

      {/* Stats Row Skeleton */}
      <div className={styles.statsRow}>
        {[...Array(5)].map((_, i) => (
          <div key={i} className={styles.statCard}>
            <Skeleton width={100} height={12} style={{ marginBottom: 8 }} />
            <Skeleton width={60} height={32} />
          </div>
        ))}
      </div>

      {/* Filter Bar Skeleton */}
      <div className={styles.filterBar}>
        <div className={styles.searchWrap}>
          <Skeleton height={38} borderRadius={8} />
        </div>
        <Skeleton width={150} height={38} borderRadius={8} />
      </div>

      {/* Table Skeleton */}
      <div className={styles.tableWrap}>
        <div style={{ padding: '16px' }}>
          {/* Table Header */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
            {[...Array(8)].map((_, i) => (
              <Skeleton key={i} width={100} height={16} />
            ))}
          </div>

          {/* Table Rows */}
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
              {[...Array(8)].map((_, j) => (
                <Skeleton key={j} width={100} height={20} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
